// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indexedStep {
    color: rgb(190, 190, 190);
    width: 30px;
    height: 30px;
    font-size: 12px;
    background-color: rgb(255, 255, 255);
    border-radius: 50%;
    border-style: solid;
    border-width: 1px;
    border-color: rgb(206, 206, 206);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.indexedStep.accomplished {
    background-color: #154354;
    color: white;
    border-style: none;
}

.RSPBprogressBar {
    height: 2px;
    width: 70%;
    line-height: 1;
    border-radius: 10px;
    position: relative;
    background-color: rgb(207, 207, 207);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    margin-bottom: 50px;
}

.RSPBprogressBar .RSPBstep {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    z-index: 0;
    position: absolute;
    transform: translateX(-50%);
    transition-property: all;
    transition-timing-function: ease;
    top: -15px;
}

.RSPBprogressBar .RSPBprogressBarText {
    color: white;
    font-size: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.RSPBprogressBar .RSPBprogression {
    position: absolute;
    transition: width 0.3s ease;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: 10px;
    background: #154354;
    z-index: -1;
}

/* @media screen and (max-width: 480px) {
    .indexedStep{
        width: 15px;
        height: 15px;
        font-size: 6px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/components/custom/stepProgressBar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,MAAM;IACN,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;;;;GAMG","sourcesContent":[".indexedStep {\n    color: rgb(190, 190, 190);\n    width: 30px;\n    height: 30px;\n    font-size: 12px;\n    background-color: rgb(255, 255, 255);\n    border-radius: 50%;\n    border-style: solid;\n    border-width: 1px;\n    border-color: rgb(206, 206, 206);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.indexedStep.accomplished {\n    background-color: #154354;\n    color: white;\n    border-style: none;\n}\n\n.RSPBprogressBar {\n    height: 2px;\n    width: 70%;\n    line-height: 1;\n    border-radius: 10px;\n    position: relative;\n    background-color: rgb(207, 207, 207);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 50px;\n    margin-bottom: 50px;\n}\n\n.RSPBprogressBar .RSPBstep {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 0;\n    position: absolute;\n    transform: translateX(-50%);\n    transition-property: all;\n    transition-timing-function: ease;\n    top: -15px;\n}\n\n.RSPBprogressBar .RSPBprogressBarText {\n    color: white;\n    font-size: 10px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.RSPBprogressBar .RSPBprogression {\n    position: absolute;\n    transition: width 0.3s ease;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    border-radius: 10px;\n    background: #154354;\n    z-index: -1;\n}\n\n/* @media screen and (max-width: 480px) {\n    .indexedStep{\n        width: 15px;\n        height: 15px;\n        font-size: 6px;\n    }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
